export * from "./PupilQuiz.view";
